/**
 * Convert milliseconds to seconds with 2 decimal places
 * @param {number} milliseconds - Duration in milliseconds
 * @returns {string} - Formatted string like "123.88 seconds"
 */
export const formatMillisecondsToSeconds = (milliseconds: number): string => {
  if (
    milliseconds === null ||
    milliseconds === undefined ||
    milliseconds < 0 ||
    isNaN(milliseconds)
  ) {
    return "0.00 s";
  }

  // Convert to seconds and format to 2 decimal places
  const seconds = (milliseconds / 1000).toFixed(2);

  return `${seconds} s`;
};
